import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CardsController } from "./cards-controller";
import { CardsPage } from "./cards-page";

export function CardsRoute({ deps }: { deps: AppDeps }) {
  return (
    <Subtree
      key="cards"
      controller={() =>
        new CardsController(
          pick(deps, "client", "authHandler", "storeRepository", "providersRepository", "reviewQueueRepository"),
        )
      }
    >
      <CardsPage />
    </Subtree>
  );
}
